import React from 'react'
import Layout from '../components/Layout'
import { Container, Typography, Box } from '@mui/material'

const Faq = () => {
  return (
    <Layout>
      <Container maxWidth="md" sx={{ pt: 10, pb: 6 }}>
        
        {/* Page Title */}
        <Typography 
          variant="h6" 
          align="center" 
          sx={{ fontWeight: 'bold', mb: 0.5 }}
        >
          All Markets
        </Typography>

        <Typography 
          align="center" 
          sx={{ mb: 4, fontSize: '15px' }}
        >
          October 2019
        </Typography>

        {/* FAQ Content */}
        <Box sx={{ fontSize: '15px', lineHeight: 1.8 }}>
          
          {/* Question 1 */}
          <p><strong>1. What is Flow’s RingBack Tones service called “Flow Tones”?</strong></p>
          <p>
            Flow Tones is a service that allows you to use selected songs (RingBack Tones)
            to replace the tone that is played when someone calls you. So instead of hearing
            the traditional ring, the caller hears the song that you have selected.
          </p>

          {/* Question 2 */}
          <p><strong>2. Are RingBack Tones different from ring tones?</strong></p>
          <p>
            Yes. A ring tone is the alert you hear from your phone when someone calls you.
            A RingBack Tone is what someone hears when they dial your number. RingBack Tones
            are stored on the FLOW network, while ring tones are saved on your phone.
          </p>

          {/* Question 3 */}
          <p><strong>3. Does it matter what phone type and model phone I’m using when subscribing to the RingBack Tones Service?</strong></p>
          <p>
            No. Your ability to successfully subscribe to the service is not dependent on the
            make and model of handset you are using. RingBack Tones is a network function and
            is activated on your customer subscriber profile, unlike ring tones that are stored
            on your phone.
          </p>

          {/* Question 4 */}
          <p><strong>4. How does the FLOW’s RingBack Tones Service work?</strong></p>
          <p>
            You must subscribe to the service and a subscription lasts for 30 days. When someone
            dials your number, the network recognizes that you are a subscriber to the RingBack
            Tones service and plays the Tone(s) that you selected for your callers to hear.
          </p>

          {/* Question 5 */}
          <p><strong>5. Is the RingBack Tones service available to all FLOW customers?</strong></p>
          <p>
            Yes. The RingBack Tones service is available to all FLOW residential and business customers.
          </p>

          {/* Question 6 */}
          <p><strong>6. How do I subscribe to the RingBack Tones service?</strong></p>

          {/* Barbados & OECS Subscription Options */}
          <Typography variant="h6" align="left" sx={{ fontWeight: 'bold', mt: 2 }}>
            Barbados & OECS
          </Typography>
          <p>You have three (3) options available for subscribing to the RingBack Tones service:</p>
          <ul>
            <li><strong>IVR (Interactive Voice Recording)</strong> by dialing <strong>12347355</strong></li>
            <li><strong>SMS (Text message)</strong> by sending keyword “sub” to <strong>12347355</strong></li>
            <li><strong>WEB</strong> by accessing web portal link <a href="http://crbcrbt" target="_blank">http://crbcrbt</a></li>
          </ul>

          {/* Jamaica Subscription Options */}
          <Typography variant="h6" align="left" sx={{ fontWeight: 'bold', mt: 2 }}>
            Jamaica
          </Typography>
          <p>You have three (3) options available for subscribing to the RingBack Tones service:</p>
          <ul>
            <li><strong>IVR (Interactive Voice Recording)</strong> by dialing <strong>4444288</strong></li>
            <li><strong>SMS (Text message)</strong> by sending keyword “sub” to <strong>4444288</strong></li>
            <li><strong>WEB</strong> by accessing web portal link <a href="http://crbt.co" target="_blank">http://crbt.co</a></li>
          </ul>

          {/* Subscribing via IVR */}
          <Typography variant="h6" align="left" sx={{ fontWeight: 'bold', mt: 2 }}>
            Subscribing via IVR
          </Typography>

          <p><strong>Barbados & OECS</strong></p>
          <p>Dial <strong>12347355</strong> and you will be prompted to press 1 to subscribe to the service. You will then receive a text message confirming your subscription as well as your IVR + WEB passwords.</p>

          <p><strong>Jamaica</strong></p>
          <p>Dial <strong>4444288</strong> and you will be prompted to press 1 to subscribe to the service. You will then receive a text message confirming your subscription as well as your IVR + WEB passwords.</p>

          {/* Subscribing via SMS */}
          <Typography variant="h6" align="left" sx={{ fontWeight: 'bold', mt: 2 }}>
            Subscribing via SMS (Text Message)
          </Typography>

          <p><strong>Barbados & OECS</strong></p>
          <p>Send Text with keyword “sub” to <strong>12347355</strong>. You will then receive a text message confirming subscription as well as the IVR + WEB passwords.</p>

          <p><strong>Jamaica</strong></p>
          <p>Send Text with keyword “sub” to <strong>4444288</strong>. You will then receive a text message confirming subscription as well as the IVR + WEB passwords.</p>

          {/* Subscribing via WEB */}
          <Typography variant="h6" align="left" sx={{ fontWeight: 'bold', mt: 2 }}>
            Subscribing via WEB
          </Typography>
          <p>Log on to the FLOW Portal website at <a href="http://crbt.co" target="_blank">http://crbt.co</a></p>
          <p>Select the new user register link and follow the instructions. You will then receive a text message with subscription activation and IVR + WEB passwords. Note: Upon subscription the customer’s number is automatically provisioned on the network for the RingBack Tones service.</p>

          {/* Question 7 */}
          <p><strong>7. What is the charge to subscribe to the Ringback Tones service?</strong></p>
          <p>The subscription fee and purchase pricing are found in the table below.</p>

          {/* Question 8 */}
          <p><strong>8. How do I know that I have subscribed to the service?</strong></p>
          <p>You will receive a text message confirming subscription. The text also includes the password to access the IVR and to log in via the website. If you have access to the web portal, you can confirm account status once you have logged in and choose My Profile from the menu.</p>

          {/* Question 9 */}
          <p><strong>9. Is there an expiry period for the subscription to the RingBack Tones service?</strong></p>
          <p>Yes. Each subscription lasts for 30 days.</p>

          {/* Additional FAQs */}
          <p><strong>10. Do I automatically get a RingBack Tone upon subscribing to the service?</strong></p>
          <p>Yes, the system automatically assigns you with the network default RingBack Tone upon subscription. You may personalize your profile immediately by purchasing and activating other available tones.</p>

          {/* Question 11 */}
          <p><strong>11. What are the features of the RingBack Tones service?</strong></p>
          <ul>
            <li>Set a RingBack Tone for all callers</li>
            <li>Set a RingBack Tone for a specific caller’s number by creating a friends list</li>
            <li>Set a RingBack Tone for a specific group of callers by creating groups</li>
            <li>Set a RingBack Tone to play on specific days and at specific times</li>
            <li>Maintain a library of RingBack Tones for selection</li>
            <li>Gift a RingBack Tone to a friend</li>
            <li>Change RingBack Tones as often as desired</li>
          </ul>

          {/* Question 12 */}
          <p><strong>12. What kinds of RingBack Tones are available?</strong></p>
          <p>RingBack Tones are available in a number of categories. The categories include:</p>
          <ul>
            <li>Dancehall</li>
            <li>Hip Hop</li>
            <li>R&B</li>
            <li>Reggae</li>
            <li>Religious/ Gospel</li>
            <li>Seasonal</li>
            <li>Soca</li>
            <li>Pop</li>
          </ul>
          <p>You can access the full list of categories and songs from all interfaces (IVR, SMS, and WEB) and the best experience will be found through the web portal.</p>

          {/* Question 13 */}
          <p><strong>13. How do I purchase a RingBack Tone?</strong></p>
          <p><strong>Barbados & OECS</strong>: A RingBack Tone can be purchased through any of the access interfaces: IVR by calling 12347355, sending a text message to 12347355, or WEB by logging on to <a href="http://crbt.co" target="_blank">http://crbt.co</a>.</p>
          <p><strong>Jamaica</strong>: A RingBack Tone can be purchased through any of the access interfaces: IVR by calling 4444288, sending a text message to 4444288, or WEB by logging on to <a href="http://crbt.co" target="_blank">http://crbt.co</a>.</p>

          {/* Additional questions can continue in similar fashion */}

        </Box>
      </Container>
    </Layout>
  )
}

export default Faq
